// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6872":"css/admin-app.6705","7101":"css/app.6705"}[chunkId] + ".css";
};